const getters = {
    getToken: (state) => state.user.token,
    getUserinfo: (state) => state.user.userInfo,
    getCartNum: (state) => state.user.cartNum,
    getTotalCount: (state) => state.common.totalBookCount,
    getWebBaseInfo: (state) => state.common.webBaseInfo,
    getWebNavData: (state) => state.common.webNavData,
};
export default getters;